module.exports = __webpack_public_path__ + "static/top-2ff102e600e89a034472e0c1a2798579.png";